const $ = jQuery.noConflict();

const HomepageInit = {
	init() {
		this.$video = $('.hero-homepage__background-file');
		this.$header = $('header.main-header');
		this.$hero = $('.hero-homepage');
		this.$heroTitle = $('.hero-homepage__title');
		if (this.$video.length > 0) this.initPage();
	},
	initPage() {
		if (sessionStorage.initiated !== 'true') {
			this.initTransitions();
			sessionStorage.initiated = 'true';
		} else {
			this.initShow()
		}
	},
	initTransitions() {
		this.$header.addClass('animated');
		this.$hero.addClass('animated');
		this.initShow();
	},
	initShow() {
		this.$header.addClass('initialized');
		this.$hero.addClass('initialized');
	},
};

export default HomepageInit;
